import _ from 'lodash';
import React from 'react';
import { formatPrice } from 'app/util';
import { orderPropType } from 'app/store/selectors/products';

import './order-cost-summary.less';

const OrderCostSummary = (props) => {
  const shippingCosts = [];
  if (props.air_filter_shipping) {
    shippingCosts.push(
      <div className='row' key='1a'>
        <div className='type'>Air Filter Shipping:</div>
        <div className='amount'>{formatPrice(props.air_filter_shipping)}</div>
      </div>,
    );
  }

  if (props.glowforge_shipping) {
    shippingCosts.push(
      <div className='row' key='2a'>
        <div className='type'>Glowforge Shipping:</div>
        <div className='amount'>{formatPrice(props.glowforge_shipping)}</div>
      </div>,
    );
  }

  if (_.isEmpty(shippingCosts) && props.shipping) {
    shippingCosts.push(
      <div className='row' key='3a'>
        <div className='type'>Shipping:</div>
        <div className='amount'>{formatPrice(props.shipping)}</div>
      </div>,
    );
  }

  let discounts;
  if (props.discounts) {
    discounts = (
      <div className='row discount'>
        <div className='type'>Discount:</div>
        <div className='amount'>-{formatPrice(props.discounts)}</div>
      </div>
    );
  }

  const adjustments = _.map(props.adjustments, (adj, index) => (
    <div className='row' key={index}>
      <div className='type'>{adj.label}:</div>
      <div className='amount'>{formatPrice(adj.amount)}</div>
    </div>
  ));

  let storeCredits;
  if (props.storeCredits) {
    storeCredits = (
      <div className='row discount'>
        <div className='type'>Store Credits:</div>
        <div className='amount'>-{formatPrice(props.storeCredits)}</div>
      </div>
    );
  }

  return (
    <div className='OrderCostSummary'>
      <div className='row'>
        <div className='type'>Subtotal:</div>
        <div className='amount'>{formatPrice(props.subtotal)}</div>
      </div>
      <div className='row'>
        <div className='type'>Taxes:</div>
        <div className='amount'>{formatPrice(props.salesTax)}</div>
      </div>
      {shippingCosts}
      {discounts}
      {storeCredits}
      {adjustments}
      <div className='row total'>
        <div className='type'>Total:</div>
        <div className='amount'>{formatPrice(props.total)}</div>
      </div>
    </div>
  );
};

OrderCostSummary.propTypes = {
  ...orderPropType,
};

export default OrderCostSummary;



// WEBPACK FOOTER //
// ./app/store/components/common/order-cost-summary.jsx